const GET_RESOURCES_METADATA = `query GetResourcesMetadata($filters:[ResourcesFilter]!) {
    getResourceMetadata(filters: $filters) {
        branding
        provider
        providerDisplayName
        resourceIcon
        resourceId
        resourceType
        resourceUniqueId
        title
        url
    }
  }`;

export default GET_RESOURCES_METADATA;
